const customScrollbar = `
  &::-webkit-scrollbar-track {
    border-radius: 15px;
    background-color: #ffffff;
  }
  &::-webkit-scrollbar {
    width: 10px;
    border-radius: 15px;
    background-color: #ffffff;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 15px;
    background-color: #999999;
  }
`;

export default customScrollbar;
